import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as globals from "app/resources/globals";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { DocumentacionGuias } from "./componentes/guias/guiasview";
import { Documentacion } from "./documentacion";
import { PagoDocumentacion, ObtenerValuePago } from "./pago";
import { DocumentacionList, GuiaList } from "../listados/index";
import { observeResource } from "kea-resource";
import { DocumentacionExitosa } from "./componentes/okmodal/index";

export { CotizacionView } from "./componentes/guias/cotizacionview";

interface Props {
    value: models.DocumentacionModel;
    onChange: (x: models.DocumentacionModel) => void;
    permisos: models.Rol;
    session: models.Session;
}

interface State {
    idDireccionDestino?: number;
}
class DocumentacionMenu extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    modalManager = kea.createModalManager();
    getField = kea.formfields(() => this.props);

    value = (props: Props) => props.value;
    servicios = createSelectorRx(this.value, x => x.servicios);
    guias = createSelectorRx(this.servicios, x => toObservable((x.IdContactoOrigen == null || x.IdSucursalOrigen == null) ? null : observeResource(resources.Documentacion.ObtenerGuias, x)));

    handleOnAceptar = async () => {
        var poliza_text = "";

        var cliente = await resources.Cliente.GetClienteByIdContacto(this.props.value.servicios.IdContactoOrigen);

        if (cliente.NumeroPoliza == null) {
            cliente.NumeroPoliza = ""
        }

        if (!cliente.SeguroViaje) {
            if ( cliente.NumeroPoliza.length != null && cliente.NumeroPoliza.length <= 0) {
                poliza_text =  "Seguro: Viaja por cuenta y riesgo del cliente"
            } else {
                poliza_text =  "Seguro: Viaja por cuenta y riesgo del cliente, póliza: ".concat(cliente.NumeroPoliza);
            }
        }

        if (this.props.value.servicios.Paquetes.length > 0) 
        {
            if ( this.props.value.servicios.Paquetes[0].Observaciones === undefined) 
            {
                this.props.value.servicios.Paquetes[0].Observaciones = "";
            }

            this.props.value.servicios.Paquetes[0].Observaciones = 
            poliza_text.concat( this.props.value.servicios.Paquetes[0].Observaciones );
        }
        
        const { servicios, pago } = this.props.value;
        const permisos = this.props.permisos;
        const newPago = ObtenerValuePago(pago, permisos.Documentacion.VerPagoContado, permisos.Documentacion.VerPagoCredito);
        //crea la guia con el pago
        const documentacionFactura = await resources.Documentacion.AgregarDocumentacion({ Servicios: servicios, PagoRealizado: newPago });

        this.handleOnLimpiar();
        if (documentacionFactura.ErrorFacturacion != null)
            await kea.message("Error en la facturación", documentacionFactura.ErrorFacturacion, "warning");

        await this.modalManager.showModal(DocumentacionExitosa, { idDocumentacion: documentacionFactura.IdDocumentacion }, undefined);
        //Si se generó una factura a partir de esta documentación se timbra
        if (documentacionFactura.IdFactura != null) {
            var mensaje = await resources.Factura.TimbrarFacturaMensajeException(documentacionFactura.IdFactura);
            if (mensaje != null)
                await kea.message("Error en el timbrado de la factura", mensaje, "warning");
        }
    }
    handleOnLimpiar = () => {
        this.props.onChange(models.documentacionModelInicial);
    }

    render() {
        const { getField } = this;
        const props = this.props;
        const guias = this.guias(this.props);
        const PagoDoc = getField(PagoDocumentacion);
        return (
            <div>
                <kea.Title titulo="Documentación" onLimpiar={this.handleOnLimpiar} />

                <kea.Tab
                    value={this.props.value.tab}
                    onChange={x => this.props.onChange({ ... this.props.value, tab: x })}
                    items={[
                        {
                            title: "Captura",
                            iconClass: fa("pencil-square-o"),
                            body: <Documentacion {... this.props} />
                        }, {
                            title: "Resumen de guías",
                            iconClass: fa("files-o"),
                            body: <DocumentacionGuias value={guias} />
                        }, {
                            title: "Pago",
                            iconClass: fa("money"),
                            body: <PagoDoc field="pago" servicios={this.props.value.servicios} onAceptar={this.handleOnAceptar} permisos={this.props.permisos} />
                        }
                    ]}
                />
                {this.modalManager.component}
            </div >
        )
    }
}



const value = globals.state.map(x => x.documentacion);
const onChange = x => globals.setState({ documentacion: x });

const DocUncontrolled = componentToRx(DocumentacionMenu);
const permisos = resources.User.PermisoRx;
const session = resources.User.SessionRx;
export class DocumentacionContainer extends React.PureComponent {
    render() {
        return <DocUncontrolled
            value={globals.state.map(x => x.documentacion)}
            onChange={x => globals.setState({ documentacion: x })}
            permisos={permisos}
            session={session}
        />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/index.tsx